import './Revenue.scss';
import React, { useState, useEffect, useMemo, useContext } from 'react';
import { BarChart, Bar, Rectangle, XAxis, YAxis, Label, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Spin } from 'antd';
import { translate } from 'react-jhipster';
import useQueryRevenueData from 'app/hooks/useQueryRevenueData';

interface RevenueProps {
  customerSelectedDate: any;
  selectedOrganizationId: string;
}

const Revenue = ({ customerSelectedDate, selectedOrganizationId }: RevenueProps) => {
  const [userRevenue, setUserRevenue] = useState([]);

  const apiParams = useMemo(
    () => ({ selectedDate: customerSelectedDate, organisationId: selectedOrganizationId, frequency: 'BY_DATE' }),
    [customerSelectedDate, selectedOrganizationId]
  );

  const { responseData, isLoading, error } = useQueryRevenueData(apiParams);

  useEffect(() => {
    if (error) {
      console.error(error);
    }
    if (responseData) {
      setUserRevenue(responseData);
    }
  }, [responseData, error]);

  const CustomizedAxisTick = ({ x, y, payload }: { x?: number; y?: number; payload?: any }) => {
    const { value: date, index } = payload;
    return (
      <g transform={`translate(${x}, ${y})`}>
        <text x="50%" y={0} dy={16} fill="#666" textAnchor="middle">
          <tspan x="0" dy="16">
            {date}
          </tspan>
          <tspan x="0" dy="16">
            ({userRevenue[index].workrecordId})
          </tspan>
        </text>
      </g>
    );
  };

  return (
    <div className="charts-wrapper">
      {isLoading ? (
        <div className="loading-section">
          <Spin tip="loading..." />
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={400}>
          <BarChart
            width={100}
            height={400}
            data={userRevenue}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" tick={<CustomizedAxisTick />} />

            <YAxis />
            <Tooltip />
            <Legend wrapperStyle={{ bottom: '-20px' }} />
            <Bar dataKey="sum" name={translate('charts.barName')} fill="#82ca9d" activeBar={<Rectangle fill="gold" stroke="purple" />} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default Revenue;
